export default class NotificationsHelper {
  static loadMessages() {
    const $notice = $('#flash .flash-notice');
    let text = $notice.text().trim();
    if (text) {
      text = text.split('#');
      NotificationsHelper.notify(text[0], text[1], 'success');
      $notice.remove();
    }

    const $alert = $('#flash .flash-alert');
    text = $alert.text().trim();
    if (text) {
      text = text.split('#');
      NotificationsHelper.notify(text[0], text[1], 'error');
      $alert.remove();
    }
  }

  static notify(title, message, type) {
    $.notify(
      {
        title,
        message,
      },
      {
        type,
        delay: 3000,
        z_index: 10000000,
        placement: {
          from: 'bottom',
          align: 'right',
        },
        template: '<div data-notify="container" class="col-xs-11 col-sm-3 alert alert-{0}" role="success"><span data-notify="title">{1}</span><span data-notify="message">{2}</span></div>',
      },
    );
  }
}
